module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(" " + _vm._s(_vm.header) + " ")]), _vm._v(" "), _c('table', {
    staticClass: "u-full-width"
  }, [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPres), function(presentation) {
    return _c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(presentation.year) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(presentation.venue) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(presentation.title) + "\n                ")])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275cbf1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/presentations.vue
// module id = 188
// module chunks = 0